export default __webpack_public_path__ + "static/media/b5964a47107bb1ce.e928a8f251177a8ff0c6988782333406.svg";